'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var preventAll = exports.preventAll = function preventAll(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
};

var preventDefault = exports.preventDefault = function preventDefault(event) {
  event.preventDefault();
};

var report = function report(callback) {
  return function (event) {
    preventAll(event);
    if (callback) {
      callback(event);
    }
  };
};

var reportOnly = function reportOnly(callback) {
  return function (event) {
    if (callback) {
      callback(event);
    }
  };
};

var getHandler = exports.getHandler = function getHandler(event, option, callback) {
  if (!option) {
    return null;
  }

  if (option === 'no-default') {
    return preventDefault;
  }

  if (option === 'report') {
    return report(callback);
  }

  if (option === 'report-only') {
    return reportOnly(callback);
  }

  return preventAll;
};

var passiveSupported = false;
try {
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveSupported = true;
      return true;
    }
  });

  window.addEventListener('test', options, options);
  window.removeEventListener('test', options, options);
} catch (err) {
  passiveSupported = false;
}
var agressiveCapture = passiveSupported ? { capture: true, passive: false } : false;

var addEvent = exports.addEvent = function addEvent(target, event, handler, capture) {
  return handler && {
    target: target,
    event: event,
    handler: (target.addEventListener(event, handler, capture && agressiveCapture), handler),
    capture: capture && agressiveCapture
  };
};

var removeEvent = exports.removeEvent = function removeEvent(_ref) {
  var target = _ref.target,
      event = _ref.event,
      handler = _ref.handler,
      capture = _ref.capture;
  return target.removeEventListener(event, handler, capture);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-locky/dist/utils.js
// module id = 366
// module chunks = 58